<mat-toolbar>
  <span>PoV Display Calculator</span>
</mat-toolbar>

<app-pov-calc></app-pov-calc>
